
<script>
import Carousel from '../Carousel/Carousel.vue';
export default {
  name: 'SignPosts',
  components: {
    Carousel,
  },
  data() {
    return {
      containerWidth: '',
      banners: [
        {
          key: 'TippersEdge',
          link: '/tippers-edge/?utm_source=punters&utm_medium=digitaldisplay&utm_campaign=signposttippersedge',
        },
        {
          key: 'Predictor',
          link: '/predictor/?utm_source=punters&utm_medium=digitaldisplay&utm_campaign=signpostpredictor',
        },
        {
          key: 'FormFinder',
          link: '/form-guide/form-finder/?utm_source=punters&utm_medium=digitaldisplay&utm_campaign=signpostformfinder',
        },
        {
          key: 'SectionalTimes',
          link: '/sectionals/?utm_source=punters&utm_medium=digitaldisplay&utm_campaign=signpostsectionals',
        },
      ],
    };
  },
  computed: {
    isMobile() {
      return this.containerWidth <= 786;
    },
  },
  mounted() {
    this.handleResize();
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    handleResize() {
      this.containerWidth = this.$refs.signPostContainer.offsetWidth;
    },
    bannerUrl(banner) {
      return `https://puntcdn.com/signposts/${banner.key}.jpg`;
    },
  },
};
</script>

<template>
  <div ref="signPostContainer" class="sign-posts__container">

    <!-- Desktop -->
    <Carousel
      v-if="!isMobile"
      :tiles-per-slide="4"
      :carousel-height="320"
      :total-tiles="banners.length"
      :link="`/`"
      title="Punters Tools"
    >
      <template v-for="(banner, index) in banners">
        <a :key="index" :href="banner.link">
          <div v-lazy:background-image="bannerUrl(banner)" 
               class="sign-post__banner"></div>
        </a>
      </template>   
    </Carousel>

    <!-- Mobile -->
    <div v-else class="sign-post__mobile">
      <h2 class="sign-post__title">Punters Tools</h2>
      <a v-for="(banner, index) in banners" 
         :key="index" 
         :href="banner.link" 
      >
        <div v-lazy:background-image="bannerUrl(banner)" 
             class="sign-post__banner"></div>
      </a>   
    </div>
  </div>
</template>


<style lang="scss" scoped>
</style>
